Namespace 'Customer.Users'

class Customer.Users.ProfileMergeView extends Backbone.View
  className: 'modal hide fade'
  template: JST['backbone/templates/customer/users/profile_merge']
  events:
    'change input:checkbox': '_onChange'
    'click #profile-merge-close': 'close'
    'click .profile-merge-go-back': '_openDefaultFooter'
    'click #profile-merge-ok': '_openMergeFooter'
    'click #profile-merge-exclude': '_openExcludeFooter'
    'click #profile-merge-ok-confirm': 'merge'
    'click #profile-merge-exclude-confirm': 'exclude'

  initialize: ({originalProfile}) ->
    @originalProfile = originalProfile

  render: =>
    @$el.html(@template())
    @_mergeCandidateCollection().fetch success: (extendedProfiles) =>
      @extendedProfiles = extendedProfiles
      @definition = @extendedProfiles.at(0).get('editable_attributes')
      @addCandidates()
      @_validate()
    @

  _openFooter: ({className}) =>
    @$el.find(".footer-container.#{className}").show()
    @$el.find(".footer-container:not(.#{className})").hide()

  _openDefaultFooter: =>
    @_openFooter className: 'default'

  _openMergeFooter: =>
    @_openFooter className: 'confirm-merge-ok'

  _openExcludeFooter: =>
    @_openFooter className: 'confirm-merge-exclude'

  _mergeCandidateCollection: =>
    new Profile.UserProfile.MergeCandidateCollection(
      []
      source: @originalProfile.mainSocialUser().get('source')
      social_network_id: @originalProfile.mainSocialUser().get('social_network_id')
    )

  addCandidates: =>
    @mergeableProfileViews = []
    @mergeableProfileViews.push(new Customer.Users.MainMergeableProfileView(@originalProfile, @definition))
    @extendedProfiles.forEach (profile) =>
      @mergeableProfileViews.push(new Customer.Users.MergeableProfileView(profile, @definition))

    for view in @mergeableProfileViews
      @$el.find('#profiles').append(view.render().el)

    @$el.find('.subtitle').html(I18n.t('user_profiles.merge.subtitle', {count: @extendedProfiles.length}))
    @$el.find('.processing').hide()
    @$el.find('.tab-content').show()

  getCustomAttributes: =>
    attributes = []
    @definition.forEach (definition) =>
      values = []
      code = definition.get('code')
      type = definition.get('attribute_type_name')
      for view in @mergeableProfileViews
        values = values.concat(view.getValues(code))
      unless values.length == 0
        attributes.push(code: code, type: type, values: values)
    attributes

  getSocialUsersToMerge: =>
    socialUsers = []
    for view in @mergeableProfileViews
      socialUsers = socialUsers.concat(view.getSocialUsersToMerge())
    socialUsers

  merge: =>
    $.ajax
      type: 'POST'
      url: '/profiles/api/merge'
      contentType: 'application/json',
      data:
        JSON.stringify(
          custom_attributes: @getCustomAttributes()
          social_users_to_merge: @getSocialUsersToMerge()
          main_social_user: @originalProfile.mainSocialUser().get('id')
        )
      success: (response) =>
        showSuccess(I18n.t('user_profiles.merge.success'))
        @trigger('profile:merged', response)
      error: =>
        showError(I18n.t('generic_error_message'))
    @close()

  exclude: =>
    return unless @extendedProfiles
    new Profile.UserProfile.UserProfileMergeExclusionCollection(
      @extendedProfiles.map (extendedProfile) =>
        first_profile_id: @originalProfile.get('profile').get('id')
        second_profile_id: extendedProfile.get('profile').get('id')
    ).save(
      success: =>
        showSuccess(I18n.t('user_profiles.merge.not_merge_success'))
        @trigger('profile:merge_excluded')
      error: =>
        showError(I18n.t('generic_error_message'))
    )
    @close()

  invalidAttributeCodes: =>
    codes = []
    @definition.forEach (definition) =>
      return if definition.get('multiple')
      code = definition.get('code')
      values = new Set
      for view in @mergeableProfileViews
        values.add(value.value) for value in view.getValues(code)
      codes.push(code) if values.size > 1
    codes

  _onChange: =>
    @_openDefaultFooter()
    @_validate()

  _validate: =>
    invalidCodes = @invalidAttributeCodes()
    @_toggleError(invalidCodes)
    @_updateErrorMessage(invalidCodes)
    @_toggleMergeButton(invalidCodes)

  _updateErrorMessage: (invalidCodes) =>
    $errorMessage = @$el.find('.error-message')
    unless invalidCodes.length
      $errorMessage.html('')
      return
    $errorMessage.html(I18n.t(
      'user_profiles.merge.duplicate_unique_values',
      count: @_countAttributes()
    ))

  _toggleError: (invalidCodes) =>
    errorSelector = ''
    notErrorSelector = '.attribute'
    for code in invalidCodes
      errorSelector += ".attribute[data-code='#{code}'] input:checkbox,"
      notErrorSelector += "[data-code!='#{code}']"
    errorSelector = errorSelector.slice(0, -1)
    notErrorSelector += ' input:checkbox'

    @$el.find(errorSelector).addClass('error')
    @$el.find(notErrorSelector).removeClass('error')

  _toggleMergeButton: (invalidCodes) =>
    disabled = invalidCodes.length > 0 or @getSocialUsersToMerge().length < 1
    @$el.find('#profile-merge-ok').prop('disabled', disabled)

  open: =>
    @$el.modal()

  close: =>
    @$el.modal('hide')

  _countAttributes: =>
    elements = @$el.find('.attribute input:checked.error:enabled')
    return new Set(Array.from(elements.map((index, element) -> element.dataset.code))).size
